module.exports = __webpack_public_path__ + "static/media/select.b5e1ed2d.png";